import React from 'react';
import moment from 'moment';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { ValidatorComponent } from 'react-material-ui-form-validator';

class ValidatedDatePicker extends ValidatorComponent {
  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    return (
      <KeyboardDateTimePicker
        {...rest}
        autoOk
        disablePast
        fullWidth
        variant="inline"
        minutesStep={5}
        format="MM/DD/YYYY hh:mm A"
        minDate={moment()}
        error={!isValid}
        helperText={(!isValid && this.getErrorMessage()) || helperText}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        InputLabelProps={{
          shrink: true,
          style: { fontSize: 20, top: '-5px', fontWeight: 'bold' },
        }}
      />
    );
  }
}

export default ValidatedDatePicker;
